export const GL_CATEGORIES = [
  { value: "COLLECTION", label: "Collection" },
  { value: "SETTLEMENT", label: "Settlement" },
  { value: "WALLET_DEPOSIT", label: "Wallet Deposit" },
  { value: "COMMISSION", label: "Commission" },
  { value: "MERCHANT_LIABILITY", label: "Merchant Liability" },
  { value: "BANK", label: "Bank" },
  { value: "SUSPENSE", label: "Suspense" },
  { value: "FEE_EXPENSE", label: "Fee Expense" },
  { value: "OTHER", label: "Other" },
];

export const CURRENCY_OPTIONS = [{ value: "NGN", label: "Naira" }];

export const NORMAL_BALANCE_OPTIONS = [
  { value: "DEBIT", label: "Debit" },
  { value: "CREDIT", label: "Credit" },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { value: "ASSET", label: "Asset" },
  { value: "LIABILITY", label: "Liability" },
  { value: "EQUITY", label: "Equity" },
  { value: "REVENUE", label: "Revenue" },
  { value: "EXPENSE", label: "Expense" },
];

export const BOOLEAN_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const GL_STATUS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
];
